import {
  FETCH_SHIPMENTS_DETAILS,
  FETCH_SHIPMENTS_DETAILS_FAILURE,
  FETCH_SHIPMENTS_DETAILS_SUCCESS,
} from './types';

const fetchShipmentDashBoardDetails = (payload) => ({
  type: FETCH_SHIPMENTS_DETAILS,
  ...payload,
});

const fetchShipmentDashBoardDetailsSuccess = (payload) => ({
  type: FETCH_SHIPMENTS_DETAILS_SUCCESS,
  ...payload,
});

const fetchShipmentDashBoardDetailsFailure = (payload) => ({
  type: FETCH_SHIPMENTS_DETAILS_FAILURE,
  ...payload,
});

export {
  fetchShipmentDashBoardDetails,
  fetchShipmentDashBoardDetailsSuccess,
  fetchShipmentDashBoardDetailsFailure,
};
